import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import moment from "moment";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { trimDecimals } from "../utils/trim-decimal";

const POSlip = ({ row, declarations, company_pan }) => {
    const parseNumber = (value) => {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    };

    const amount = parseNumber(row?.amount);
    const sgstField = parseNumber(row?.sgst);
    const cgstField = parseNumber(row?.cgst);
    const transport = parseNumber(row?.transport_amount);
    const total_inclusive = amount + transport;

    const sgst_amount = (total_inclusive / 100) * sgstField;
    const cgst_amount = (total_inclusive / 100) * cgstField;

    const total =
        total_inclusive +
        (total_inclusive * sgstField) / 100 +
        (total_inclusive * cgstField) / 100;

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });
    return (
        <>
            <div className="d-flex justify-content-center align-items-center">
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => reactToPrintFn()}
                >
                    Print
                </button>
            </div>
            <div className="card d-none">
                <div className="card-inner p-0 m-0">
                    <div
                        className="card-body table-responsive p-5 pb-0"
                        ref={contentRef}
                    >
                        <table
                            className="table table-bordered"
                            style={{ fontSize: "11px" }}
                        >
                            <thead>
                                <tr className="border-0">
                                    <th
                                        colSpan={8}
                                        className="text-center border-0"
                                    >
                                        PURCHASE ORDER
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={1} rowSpan={3}>
                                        <img
                                            className="logo-small logo-img logo-img-small"
                                            src="./assets/images/gev-logo-dark.png"
                                            srcSet="./assets/images/gev-logo-dark.png 2x"
                                            alt="gev-logo"
                                        />
                                    </td>
                                    <td colSpan={3} rowSpan={3}>
                                        <p className="m-0 p-0">Invoice To</p>
                                        <p className="m-0 p-0">
                                            <strong>GREEN EDGE VENTURES</strong>
                                        </p>
                                        <p className="m-0 p-0">
                                            {row?.ship_to}
                                        </p>
                                        <p className="m-0 p-0">
                                            GST No: {row?.company_gst_number}
                                        </p>
                                    </td>
                                    <td colSpan={2}>Voucher No.</td>
                                    <td colSpan={2}>
                                        Dated <br />
                                        <strong>
                                            {moment(row?.created_at)
                                                .format("DD-MMM-YY")
                                                .toUpperCase()}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}></td>
                                    <td colSpan={2}>
                                        Mode/Terms of Payment <br />
                                        <strong>{row?.payment_terms}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        Reference No. & Date. <br />
                                        <strong>{row?.po_number}</strong>
                                    </td>
                                    <td colSpan={2}>Other References</td>
                                </tr>
                                <tr>
                                    <td colSpan={4} rowSpan={2}>
                                        <p className="m-0 p-0">
                                            Consignee (Ship to)
                                        </p>
                                        <p className="m-0 p-0">
                                            <strong>GREEN EDGE VENTURES</strong>
                                        </p>
                                        <p className="m-0 p-0">
                                            {row?.ship_to}
                                        </p>
                                        <p className="m-0 p-0">
                                            GST No:{" "}
                                            {row?.company_gst_number ?? "N/A"}
                                        </p>
                                    </td>
                                    <td colSpan={2} rowSpan={1}>
                                        Dispatched through
                                    </td>
                                    <td colSpan={2} rowSpan={1}>
                                        Destination
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4} rowSpan={2}>
                                        Terms of Delivery <br />
                                        <strong>
                                            {row?.terms_of_delivery}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <p className="m-0 p-0">
                                            Supplier (Bill from)
                                        </p>
                                        <p className="m-0 p-0">
                                            <strong>
                                                {row?.supplier?.supplier_name}
                                            </strong>
                                        </p>
                                        <p className="m-0 p-0">
                                            {row?.supplier?.supplier_address}
                                        </p>
                                        <p className="m-0 p-0">
                                            GST No:{" "}
                                            {row?.supplier?.supplier_gst ??
                                                "N/A"}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sr No.</td>
                                    <td>Description of Goods</td>
                                    <td>Due on</td>
                                    <td>Quantity</td>
                                    <td>Rate</td>
                                    <td>Per</td>
                                    <td>Disc %</td>
                                    <td>Amount</td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>
                                        <strong>{row?.item?.item_name}</strong>
                                    </td>
                                    <td>
                                        <strong>
                                            {moment(row?.delivery_date)
                                                .format("DD-MMM-YY")
                                                .toUpperCase()}
                                        </strong>
                                    </td>
                                    <td>
                                        <strong>{row?.quantity}</strong>
                                    </td>
                                    <td>
                                        <strong>{row?.rate}</strong>
                                    </td>
                                    <td>
                                        <strong>{row?.per_quantity}</strong>
                                    </td>
                                    <td></td>
                                    <td>
                                        <strong>{amount}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>
                                        <strong>Transport</strong>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <strong>{transport}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>
                                        <strong>CGST</strong>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <strong>{cgst_amount}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>
                                        <strong>SGST</strong>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <strong>{sgst_amount}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <strong>Total</strong>
                                    </td>
                                    <td colSpan={5}></td>
                                    <td>{trimDecimals(total, 5)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>
                                        <div className="d-flex justify-content-between">
                                            <span>
                                                Amount chargable (in words)
                                            </span>
                                            <span>E. & O.E</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>
                                        <strong>
                                            INR
                                            <span className="mx-1">
                                                {row?.amount_in_words}
                                            </span>
                                            Only
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>
                                        Company's PAN:
                                        <strong>{company_pan}</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <p className="underline">Declaration</p>
                                        {declarations?.map(
                                            (d, i) => `${i + 1}.  ${d}  `
                                        )}
                                    </td>
                                    <td colSpan={4}>
                                        <p className="text-end">
                                            <strong>
                                                for GREEN EDGE VENTURES
                                            </strong>
                                        </p>
                                        <br />
                                        <br />
                                        <p className="text-end">
                                            Authorised Signatory
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr className="border-0">
                                    <th
                                        colSpan={8}
                                        className="text-center border-0"
                                    >
                                        SUBJECT TO SURAT JURISDICTION
                                    </th>
                                </tr>
                                <tr className="border-0">
                                    <th
                                        colSpan={8}
                                        className="text-center border-0"
                                    >
                                        This is a Computer Generated Document
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default POSlip;
